// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadingSpinner_loadingContainer__liZEz {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  background-color: rgba(0, 0, 0, 0.92);
  z-index: 9999;
}

.LoadingSpinner_logoWrap__RikBr {
  display: flex;
  justify-content: center;
  align-items: center;
  animation: LoadingSpinner_logoBreath__Z32Bl 3.6s ease-in-out infinite;
}

@keyframes LoadingSpinner_logoBreath__Z32Bl {
  0%, 100% { transform: scale(1); }
  45%, 55% { transform: scale(1.03); }
}

.LoadingSpinner_loadingText__sUUCP {
  color: rgba(255, 255, 255, 0.75);
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0.5px;
  margin: 0;
  animation: LoadingSpinner_textPulse__4r9cJ 2s ease-in-out infinite;
}

@keyframes LoadingSpinner_textPulse__4r9cJ {
  0%, 100% { opacity: 0.55; }
  50% { opacity: 1; }
}

/* Fade out animation for TodayModal */
.LoadingSpinner_fadeOut__AAbGn {
  animation: LoadingSpinner_fadeOut__AAbGn 0.3s ease-out forwards;
}

@keyframes LoadingSpinner_fadeOut__AAbGn {
  from { opacity: 1; }
  to { opacity: 0; }
}`, "",{"version":3,"sources":["webpack://./src/components/LoadingSpinner.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qEAA+C;AACjD;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,WAAW,sBAAsB,EAAE;AACrC;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;EACT,kEAA4C;AAC9C;;AAEA;EACE,WAAW,aAAa,EAAE;EAC1B,MAAM,UAAU,EAAE;AACpB;;AAEA,sCAAsC;AACtC;EACE,+DAAyC;AAC3C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB","sourcesContent":[".loadingContainer {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 24px;\r\n  background-color: rgba(0, 0, 0, 0.92);\r\n  z-index: 9999;\r\n}\r\n\r\n.logoWrap {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  animation: logoBreath 3.6s ease-in-out infinite;\r\n}\r\n\r\n@keyframes logoBreath {\r\n  0%, 100% { transform: scale(1); }\r\n  45%, 55% { transform: scale(1.03); }\r\n}\r\n\r\n.loadingText {\r\n  color: rgba(255, 255, 255, 0.75);\r\n  font-size: 16px;\r\n  font-weight: 300;\r\n  letter-spacing: 0.5px;\r\n  margin: 0;\r\n  animation: textPulse 2s ease-in-out infinite;\r\n}\r\n\r\n@keyframes textPulse {\r\n  0%, 100% { opacity: 0.55; }\r\n  50% { opacity: 1; }\r\n}\r\n\r\n/* Fade out animation for TodayModal */\r\n.fadeOut {\r\n  animation: fadeOut 0.3s ease-out forwards;\r\n}\r\n\r\n@keyframes fadeOut {\r\n  from { opacity: 1; }\r\n  to { opacity: 0; }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingContainer": `LoadingSpinner_loadingContainer__liZEz`,
	"logoWrap": `LoadingSpinner_logoWrap__RikBr`,
	"logoBreath": `LoadingSpinner_logoBreath__Z32Bl`,
	"loadingText": `LoadingSpinner_loadingText__sUUCP`,
	"textPulse": `LoadingSpinner_textPulse__4r9cJ`,
	"fadeOut": `LoadingSpinner_fadeOut__AAbGn`
};
export default ___CSS_LOADER_EXPORT___;
